import Model from "../Model";

class BackEmployee extends Model{

    buildUrl ({ param }) {
        return ['employeelink', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BackEmployee;